import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  update: false,
  data: null,
};

const dodavatel = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_DODAVATEL_REQUEST:
      return { ...state, update: false, isLoading: true };

    case actionTypes.GET_DODAVATEL_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };

    case actionTypes.GET_DODAVATEL_FAILURE:
      return _initState;

    case actionTypes.CHANGE_DODAVATEL:
      return { ...state, isLoading: false, data: action.data };

    case actionTypes.UPDATE_DODAVATEL:
      return { ...state, update: action.update };

    default:
      return state;
  }
};

export default dodavatel;
